import api from '../../../../../configurations/service';
import * as types from './mutation-types';

export const saveBeneficio = async (_, data) => {
  await api().post('fiscal.post-beneficio-fiscal', data);
};

export const getBeneficio = async (context, search) => {
  const { data } = await api().post('fiscal.get-beneficio-fiscal', search);
  context.commit(types.SET_CODIGO_BENEFICIOS, data);
};

export const deleteBeneficio = async (context, form) => {
  const { data } = await api().post('fiscal.delete-beneficio-fiscal', form);
  context.commit(types.SET_CODIGO_BENEFICIOS, data);
};

export const getBeneficioId = async (context, beneficioCollection) => {
  const { id } = beneficioCollection;
  const { data } = await api().post('fiscal.get-beneficio-fiscal', {
    id,
  });
  return data;
};

export const setBeneficio = async (context, beneficio) => {
  context.commit(types.SET_CODIGO_BENEFICIO, beneficio);
};

export const resetBeneficioState = async (context) => {
  context.commit(types.RESET_CODIGO_BENEFICIO);
};

export const setSemCBENEF = async (context, checked) => {
  context.commit(types.SET_SEM_CBENEF, checked);
};
